export default __webpack_public_path__ + "static/media/confirmation.47d11eb0.svg";